var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 576,
    viewBox: "0 0 1000 576",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.9474 0 0 1.9474 504.0102 271.8322)",
    id: 826541
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.1071 87.954)",
    id: "Process_Line"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-317.3529, -407.414)",
    d: "M 317.28 474.5 c -62.06 0 -124.13 0.04 -186.19 -0.01 c -40.52 -0.03 -69.89 -28.27 -69.98 -67.13 c -0.09 -38.32 30.09 -67.25 70.19 -67.25 c 124.48 0.02 248.96 0.02 373.44 0.12 c 37.02 0.03 64.65 25.89 68.57 63.86 c 3.16 30.56 -20.23 62.92 -52.25 68.58 c -17.3 3.05 -35.42 1.77 -53.17 1.84 c -50.21 0.19 -100.42 0.07 -150.62 0.07 c 0 -0.02 0 -0.05 0 -0.07 Z m 184.51 -97.09 c -16.44 0.18 -30.01 13.73 -29.9 29.87 c 0.11 16.7 14.14 30.72 30.62 30.6 c 17.41 -0.13 30.13 -13.09 30 -30.55 c -0.13 -17.16 -13.43 -30.11 -30.72 -29.92 Z m -122.4 30.02 c 0.07 16.94 13.77 30.71 30.38 30.54 c 16.42 -0.18 30.49 -14.55 30.31 -30.95 c -0.18 -16.08 -13.85 -29.51 -30.17 -29.65 c -17.11 -0.14 -30.58 13.13 -30.52 30.06 Z m -155.07 -30 c -17.02 0.03 -30.66 13.4 -30.72 30.12 c -0.06 16.32 14.58 30.88 30.67 30.48 c 16.93 -0.41 30.07 -14.04 29.94 -31.05 c -0.13 -16.51 -13.35 -29.59 -29.89 -29.56 Z m -123.16 30.68 c 0.06 16.29 13.71 29.97 29.87 29.94 c 16.52 -0.03 30.73 -14.14 30.71 -30.52 c -0.01 -16.75 -13.65 -30.1 -30.71 -30.06 c -17.11 0.04 -29.94 13.2 -29.87 30.64 Z m 216.37 -30.71 c -17.43 -0.22 -30.76 12.69 -30.86 29.9 c -0.09 16.55 12.92 30.11 29.4 30.64 c 16.36 0.53 30.82 -13.58 31.07 -30.32 c 0.24 -16.4 -13.09 -30.02 -29.62 -30.23 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -96.7066 -67.6639)",
    id: "Process_Line"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-222.7535, -251.7961)",
    d: "M 293.88 181.12 v 141.73 H 151.78 c 0 -3.31 0 -6.62 0 -9.92 c 0.02 -40.09 0.32 -80.18 -0.15 -120.27 c -0.11 -9.34 2.72 -12.35 11.88 -11.71 c 10.06 0.71 20.27 0.79 30.3 -0.09 c 10.12 -0.89 12.72 3.26 12.14 12.56 c -0.66 10.62 -0.15 21.31 -0.15 34.47 c 12.23 -7.1 22.93 -10.02 33.69 -0.1 c 0.68 -0.86 1.36 -1.71 2.05 -2.57 c 0 -10.92 0.49 -21.87 -0.16 -32.76 c -0.5 -8.39 1.66 -12.05 10.86 -11.55 c 13.51 0.72 27.09 0.19 41.64 0.19 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 89.5339 -67.4545)",
    id: "Process_Line"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-408.9939, -252.0055)",
    d: "M 480.49 323.14 h -142.81 c 0 -7.13 0 -13.95 0 -20.78 c -0.03 -36.92 0.15 -73.85 -0.24 -110.77 c -0.09 -8.28 2.51 -11.14 10.79 -10.67 c 11.11 0.63 22.3 0.59 33.43 0.06 c 7.48 -0.36 9.87 2.65 9.69 9.67 c -0.29 11.63 -0.08 23.28 -0.08 37.81 c 12.48 -8.46 22.9 -9.68 35.97 0.58 c 0 -12.26 -0.07 -21.02 0.01 -29.77 c 0.23 -22.41 -0.63 -17.67 17.62 -18.15 c 9.05 -0.24 18.12 0.16 27.17 -0.08 c 5.43 -0.15 8.52 1.23 8.51 7.44 c -0.11 44.52 -0.06 89.05 -0.06 134.66 Z",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.0d05f373dc863b50d5079c56bcc5762c.svg";
export { ForwardRef as ReactComponent };